export default __webpack_public_path__ + "static/media/card.303cc152.jpg";